export const RESPONSE_ERRORS = Object.freeze({
  TWO_FA_ENABLED: "2FA is enabled",
  CODE_REQUIRED: "Code required",
  INCORRECT_CODE: "The code field is required",
});

export default {};
